import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { endpoints, type RecipeSummary } from '../api/endpoints';
import { RecipeCard } from './RecipeCard';
import { Skeleton } from './states';

// Горизонтальная полка рецептов одной кухни на главном. Тянет до 10 рецептов;
// «Показать все» ведёт в браузер кухни (/cuisine/:key). Пустая/сбойная полка скрывается,
// чтобы не ломать ленту (на главный кухня попадает по count>=6, но это подстраховка).
export function CuisineShelf({ cuisineKey, label }: { cuisineKey: string; label: string }) {
  const nav = useNavigate();
  const [items, setItems] = useState<RecipeSummary[] | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    endpoints.getRecipesByCuisine(cuisineKey, 10).then(
      (r) => {
        if (alive) setItems(r.items);
      },
      () => {
        if (alive) setFailed(true);
      },
    );
    return () => {
      alive = false;
    };
  }, [cuisineKey]);

  if (failed) return null;
  if (items && items.length === 0) return null;

  return (
    <section aria-label={label}>
      <div className="mb-2 flex items-baseline justify-between px-1">
        <h2 className="text-[17px] font-bold text-ink">{label}</h2>
        <button
          onClick={() => nav(`/cuisine/${cuisineKey}`)}
          className="text-sm font-medium text-primary-700 transition active:scale-95"
        >
          Показать все
        </button>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {items === null
          ? [0, 1, 2].map((i) => <Skeleton key={i} className="h-44 w-44 shrink-0" />)
          : items.map((r) => (
              <div key={r.id} className="w-44 shrink-0">
                <RecipeCard
                  title={r.title ?? ''}
                  imageUrl={r.imageUrl}
                  cookTimeMin={r.cookTimeMin}
                  servings={r.servings}
                  onClick={() => nav(`/recipe/${r.id}`)}
                />
              </div>
            ))}
      </div>
    </section>
  );
}
